"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const MenuItem_1 = require("../Menu/MenuItem");
const SubMenuItem_1 = require("../Menu/SubMenuItem");
const createSubMenuItem = (subItem, index, testId) => {
    const { label, onTrigger, isActive } = subItem;
    return (react_1.default.createElement(SubMenuItem_1.SubMenuItem, { key: index, label: label, isActive: isActive, onTrigger: onTrigger, testId: testId }));
};
const createMenuItem = (mainItem, index, testId) => {
    const { label, icon, isActive, onTrigger, subItems } = mainItem;
    return (react_1.default.createElement(MenuItem_1.MenuItem, { key: index, label: label, icon: icon, onTrigger: onTrigger, isActive: isActive, testId: testId }, subItems?.map((item, idx) => createSubMenuItem(item, idx, testId))));
};
exports.createMenuItem = createMenuItem;
